export const KITS = [
  {
    id: "starter-kit",
    name: "Starter Mechanic Kit",
    short: "Starter",
    price: 67,
    badge: "FIELD-TESTED FOR MOBILE WRENCHERS",
    target: "Mobile mechanics & solo operators launching independent runs",
    blurb: "Lock down customer intake, kill bogus damage claims, and collect same-day payment — without expensive SaaS fees.",
    items: [
      "Customer Intake & Vehicle Damage Inspection Sheet",
      "Work Authorization Form with diagnostic fee agreement",
      "Repair Estimate Template with parts vs. labor terms",
      "One-Page Customer Warranty Explainer",
      "Mobile Payment Collection Checklist (Square & cash protocols)",
    ],
  },
  {
    id: "shop-builder-kit",
    name: "Shop Builder Kit",
    short: "Shop Builder",
    price: 147,
    badge: "MOST POPULAR FOR NEW SHOP OWNERS",
    popular: true,
    target: "1–3 bay shops moving from hustle to structured profit",
    blurb: "Everything in Starter, plus binding legal agreements, customer financing, late-fee collections, and the profit calculator.",
    items: [
      "Everything in the Starter Kit",
      "Repair Order Terms & Conditions with Lien Rights clause",
      "Customer Payment Plan & Promissory Note Agreement",
      "Late-Payment Escalation Scripts (SMS, phone, demand letter)",
      "Shop Labor Rate & Margin Profit Calculator (Excel)",
      "Sublet / Specialty Work Authorization Addendum",
    ],
  },
  {
    id: "complete-shop-system",
    name: "Complete Shop System",
    short: "Complete",
    price: 297,
    badge: "ALL-ACCESS COMMERCIAL MASTER SYSTEM",
    target: "Established shops replacing $300/mo software for good",
    blurb: "The unabridged admin operating system: tech incentives, vendor disputes, loaner agreements, diagnostic billing, and the SOP binder.",
    items: [
      "Everything in Starter & Shop Builder",
      "Technician Efficiency & Flat-Rate Incentive Matrix",
      "Vendor & Parts Return Dispute Kit — stop supplier shrinkage",
      "Courtesy / Loaner Vehicle Agreement with insurance release",
      "Diagnostic & Teardown Fee Pre-Authorization Contract",
      "Shop Standard Operating Procedures (SOP) Master Binder",
      "Lifetime updates — real printable PDF + editable Excel files",
    ],
  },
];

export const COMPARISON = [
  { feature: "Customer intake & work authorization", starter: true, builder: true, complete: true },
  { feature: "Estimate template with terms", starter: true, builder: true, complete: true },
  { feature: "One-page warranty explainer", starter: true, builder: true, complete: true },
  { feature: "Payment collection checklist", starter: true, builder: true, complete: true },
  { feature: "Repair order T&C + lien rights", starter: false, builder: true, complete: true },
  { feature: "Payment plan & promissory note", starter: false, builder: true, complete: true },
  { feature: "Late-payment escalation scripts", starter: false, builder: true, complete: true },
  { feature: "Labor rate & profit calculator (Excel)", starter: false, builder: true, complete: true },
  { feature: "Sublet work authorization", starter: false, builder: true, complete: true },
  { feature: "Technician incentive matrix", starter: false, builder: false, complete: true },
  { feature: "Vendor & parts return dispute kit", starter: false, builder: false, complete: true },
  { feature: "Loaner vehicle agreement", starter: false, builder: false, complete: true },
  { feature: "Diagnostic & teardown pre-authorization", starter: false, builder: false, complete: true },
  { feature: "SOP master binder", starter: false, builder: false, complete: true },
  { feature: "Lifetime updates", starter: false, builder: "v2 updates", complete: true },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHdvcmtpbmclMjB0b29scyUyMGF1dG8lMjBzaG9wfGVufDB8fHx8MTc5MDUwMTUxNXww&ixlib=rb-4.1.0&q=85",
  toolRack: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxtZWNoYW5pYyUyMHdvcmtpbmclMjB0b29scyUyMGF1dG8lMjBzaG9wfGVufDB8fHx8MTc5MDUwMTUxNXww&ixlib=rb-4.1.0&q=85",
  lift: "https://images.unsplash.com/photo-1723099971299-3789db53604c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjYXIlMjBtZWNoYW5pYyUyMHdvcmtzaG9wJTIwZ2FyYWdlfGVufDB8fHx8MTc5MDUwMTUyMnww&ixlib=rb-4.1.0&q=85",
  toolbox: "https://images.unsplash.com/photo-1637640125496-31852f042a60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxhdXRvJTIwcmVwYWlyJTIwd29ya3Nob3AlMjB0b29scyUyMHdyZW5jaHxlbnwwfHx8fDE3OTA1MDE1MTV8MA&ixlib=rb-4.1.0&q=85",
  engine: "https://images.unsplash.com/photo-1517524206127-48bbd363f3d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMHdvcmtpbmclMjB0b29scyUyMGF1dG8lMjBzaG9wfGVufDB8fHx8MTc5MDUwMTUxNXww&ixlib=rb-4.1.0&q=85",
};
